module.exports = __webpack_public_path__ + "698a91a931eda5b6d2c81beadeb91560.png";